class AsyncEvent {

  private readonly _listeners: (() => Promise<boolean>)[] = [];

  public get hasListeners(): boolean {
    return this._listeners.length > 0;
  }

  public join(listener: () => Promise<boolean>): void {
    this._listeners.push(listener);
  }

  public async complete(): Promise<boolean> {
    const result = await Promise
      .all(this._listeners.map(listener => listener()));

    return result.every(r => r);
  }
}

export const EventUtil = {
  createCustomEvent<TDetail>(
    type: string,
    detail: TDetail,
    // Justification: Conflicting ts-lint rules.
    // tslint:disable-next-line: typedef
    cancelable = false
  ): CustomEvent<TDetail> {
    // Justification: CustomEvent constructor not supported in IE11.
    // tslint:disable-next-line:strict-type-predicates
    if (typeof CustomEvent === "function") {
      return new CustomEvent(type, {
        bubbles: true,
        cancelable,
        detail
      });
    }

    const event: CustomEvent<TDetail> = document.createEvent("CustomEvent");
    event.initCustomEvent(type, true, cancelable, detail);

    return event;
  },

  listenAsyncEvent(
    type: string,
    handler: () => Promise<boolean>,
    context: EventTarget = window
  ): void {
    context.addEventListener(type, (evt: Event) => {
      const customEvent = evt as CustomEvent<AsyncEvent>;
      const asyncEvent = customEvent.detail;
      if (asyncEvent instanceof AsyncEvent) {
        asyncEvent.join(handler);
      }
    });
  },

  dispatchAsyncEvent(element: Element, type: string): Promise<boolean> | null {
    const detail = new AsyncEvent();
    const event = EventUtil.createCustomEvent(type, detail);
    element.dispatchEvent(event);

    // return detail.hasListeners
    //   ? detail.complete()
      // : new Promise<boolean>(() => true);
      return detail.complete();
  }
};
